import { ucfirst } from '../../search/index/utils'

const prefectures = [
  { "name": "北海道", "tw_name": "北海道", "roman": "hokkaido", "country": 'jp' },
  { "name": "青森県", "tw_name": "青森縣", "roman": "aomori", "country": 'jp' },
  { "name": "岩手県", "tw_name": "岩手縣", "roman": "iwate", "country": 'jp' },
  { "name": "宮城県", "tw_name": "宮城縣", "roman": "miyagi", "country": 'jp' },
  { "name": "秋田県", "tw_name": "秋田縣", "roman": "akita", "country": 'jp' },
  { "name": "山形県", "tw_name": "山形縣", "roman": "yamagata", "country": 'jp' },
  { "name": "福島県", "tw_name": "福島縣", "roman": "fukushima", "country": 'jp' },
  { "name": "茨城県", "tw_name": "茨城縣", "roman": "ibaraki", "country": 'jp' },
  { "name": "栃木県", "tw_name": "栃木縣", "roman": "tochigi", "country": 'jp' },
  { "name": "群馬県", "tw_name": "群馬縣", "roman": "gunma", "country": 'jp' },
  { "name": "埼玉県", "tw_name": "埼玉縣", "roman": "saitama", "country": 'jp' },
  { "name": "千葉県", "tw_name": "千葉縣", "roman": "chiba", "country": 'jp' },
  { "name": "東京都", "tw_name": "東京都", "roman": "tokyo", "country": 'jp' },
  { "name": "神奈川県", "tw_name": "鹿兒島縣", "roman": "kanagawa", "country": 'jp' },
  { "name": "新潟県", "tw_name": "新潟縣", "roman": "niigata", "country": 'jp' },
  { "name": "富山県", "tw_name": "富山縣", "roman": "toyama", "country": 'jp' },
  { "name": "石川県", "tw_name": "石川縣", "roman": "ishikawa", "country": 'jp' },
  { "name": "福井県", "tw_name": "福井縣", "roman": "fukui", "country": 'jp' },
  { "name": "山梨県", "tw_name": "山梨縣", "roman": "yamanashi", "country": 'jp' },
  { "name": "長野県", "tw_name": "長野縣", "roman": "nagano", "country": 'jp' },
  { "name": "岐阜県", "tw_name": "岐阜縣", "roman": "gifu", "country": 'jp' },
  { "name": "静岡県", "tw_name": "靜岡縣", "roman": "shizuoka", "country": 'jp' },
  { "name": "愛知県", "tw_name": "愛知縣", "roman": "aichi", "country": 'jp' },
  { "name": "三重県", "tw_name": "三重縣", "roman": "mie", "country": 'jp' },
  { "name": "滋賀県", "tw_name": "滋賀縣", "roman": "shiga", "country": 'jp' },
  { "name": "京都府", "tw_name": "京都府", "roman": "kyoto", "country": 'jp' },
  { "name": "大阪府", "tw_name": "大阪府", "roman": "osaka", "country": 'jp' },
  { "name": "兵庫県", "tw_name": "兵庫縣", "roman": "hyogo", "country": 'jp' },
  { "name": "奈良県", "tw_name": "奈良縣", "roman": "nara", "country": 'jp' },
  { "name": "和歌山県", "tw_name": "和歌山縣", "roman": "wakayama", "country": 'jp' },
  { "name": "鳥取県", "tw_name": "鳥取縣", "roman": "tottori", "country": 'jp' },
  { "name": "島根県", "tw_name": "島根縣", "roman": "shimane", "country": 'jp' },
  { "name": "岡山県", "tw_name": "岡山縣", "roman": "okayama", "country": 'jp' },
  { "name": "広島県", "tw_name": "廣島縣", "roman": "hiroshima", "country": 'jp' },
  { "name": "山口県", "tw_name": "山口縣", "roman": "yamaguchi", "country": 'jp' },
  { "name": "徳島県", "tw_name": "德島縣", "roman": "tokushima", "country": 'jp' },
  { "name": "香川県", "tw_name": "香川縣", "roman": "kagawa", "country": 'jp' },
  { "name": "愛媛県", "tw_name": "愛媛縣", "roman": "ehime", "country": 'jp' },
  { "name": "高知県", "tw_name": "高知縣", "roman": "kochi", "country": 'jp' },
  { "name": "福岡県", "tw_name": "福岡縣", "roman": "fukuoka", "country": 'jp' },
  { "name": "佐賀県", "tw_name": "佐賀縣", "roman": "saga", "country": 'jp' },
  { "name": "長崎県", "tw_name": "長崎縣", "roman": "nagasaki", "country": 'jp' },
  { "name": "熊本県", "tw_name": "熊本縣", "roman": "kumamoto", "country": 'jp' },
  { "name": "大分県", "tw_name": "大分縣", "roman": "oita", "country": 'jp' },
  { "name": "宮崎県", "tw_name": "宮崎縣", "roman": "miyazaki", "country": 'jp' },
  { "name": "鹿児島県", "tw_name": "鹿兒島縣", "roman": "kagoshima", "country": 'jp' },
  { "name": "沖縄県", "tw_name": "沖繩縣", "roman": "okinawa", "country": 'jp' },
  { "name": "ハノイ", "tw_name": "河內", "roman": "ha_noi", "country": 'vn' },
  { "name": "ホーチミン", "tw_name": "胡志明市", "roman": "ho_chi_minh", "country": 'vn' },
  { "name": "ダナン", "tw_name": "峴港", "roman": "da_nang", "country": 'vn' },
  { "name": "ハイフォン", "tw_name": "海防", "roman": "hai_phong", "country": 'vn' },
  { "name": "カントー", "tw_name": "芹苴", "roman": "can_tho", "country": 'vn' },
  { "name": "ソンラ省", "tw_name": "山羅省", "roman": "son_la", "country": 'vn' },
  { "name": "ホアビン省", "tw_name": "和平省", "roman": "hoa_binh", "country": 'vn' },
  { "name": "ディエンビエン省", "tw_name": "奠邊省", "roman": "dien_bien", "country": 'vn' },
  { "name": "ライチャウ省", "tw_name": "萊州省", "roman": "lai_chau", "country": 'vn' },
  { "name": "イエンバイ省", "tw_name": "安沛省", "roman": "yen_bai", "country": 'vn' },
  { "name": "カオバン省", "tw_name": "高平省", "roman": "cao_bang", "country": 'vn' },
  { "name": "クアンニン省", "tw_name": "廣寧省", "roman": "quang_ninh", "country": 'vn' },
  { "name": "タイグエン省", "tw_name": "太原府", "roman": "thai_nguyen", "country": 'vn' },
  { "name": "トゥエンクアン省", "tw_name": "宣光省", "roman": "tuyen_quang", "country": 'vn' },
  { "name": "バクザン省", "tw_name": "北江省", "roman": "bac_giang", "country": 'vn' },
  { "name": "ハザン省", "tw_name": "河江省", "roman": "ha_giang", "country": 'vn' },
  { "name": "バックカン省", "tw_name": "北幹省", "roman": "bac_kan", "country": 'vn' },
  { "name": "フート省", "tw_name": "富壽省", "roman": "phu_tho", "country": 'vn' },
  { "name": "ラオカイ省", "tw_name": "老街省", "roman": "lao_cai", "country": 'vn' },
  { "name": "ランソン省", "tw_name": "諒山省", "roman": "lang_son", "country": 'vn' },
  { "name": "ヴィンフック省", "tw_name": "永福省", "roman": "vinh_phuc", "country": 'vn' },
  { "name": "バクニン省", "tw_name": "北寧省", "roman": "bac_ninh", "country": 'vn' },
  { "name": "タイビン省", "tw_name": "太平省", "roman": "thai_binh", "country": 'vn' },
  { "name": "ナムディン省", "tw_name": "南定省", "roman": "nam_dinh", "country": 'vn' },
  { "name": "ハイズオン省", "tw_name": "海陽省", "roman": "hai_duong", "country": 'vn' },
  { "name": "ハナム省", "tw_name": "河南省", "roman": "ha_nam", "country": 'vn' },
  { "name": "フンイエン省", "tw_name": "興安省", "roman": "hung_yen", "country": 'vn' },
  { "name": "ニンビン省", "tw_name": "寧平省", "roman": "ninh_binh", "country": 'vn' },
  { "name": "クアンチ省", "tw_name": "廣治省", "roman": "quang_tri", "country": 'vn' },
  { "name": "クアンビン省", "tw_name": "廣平省", "roman": "quang_binh", "country": 'vn' },
  { "name": "ゲアン省", "tw_name": "義安省", "roman": "nghe_an", "country": 'vn' },
  { "name": "タインホア省", "tw_name": "清化省", "roman": "thanh_hoa", "country": 'vn' },
  { "name": "トゥアティエン＝フエ省", "tw_name": "承天順化省", "roman": "thua_thien-hue", "country": 'vn' },
  { "name": "ハティン省", "tw_name": "河靜省", "roman": "ha_tinh", "country": 'vn' },
  { "name": "カインホア省", "tw_name": "慶和省", "roman": "khanh_hoa", "country": 'vn' },
  { "name": "クアンガイ省", "tw_name": "廣義省", "roman": "quang_ngai", "country": 'vn' },
  { "name": "クアンナム省", "tw_name": "廣南省", "roman": "quang_nam", "country": 'vn' },
  { "name": "ビンディン省", "tw_name": "平定省", "roman": "binh_dinh", "country": 'vn' },
  { "name": "フーイエン省", "tw_name": "富安省", "roman": "phu_yen", "country": 'vn' },
  { "name": "ニントゥアン省", "tw_name": "寧順省", "roman": "ninh_thuan", "country": 'vn' },
  { "name": "ビントゥアン省", "tw_name": "平順省", "roman": "binh_thuan", "country": 'vn' },
  { "name": "コントゥム省", "tw_name": "昆嵩省", "roman": "kon_tum", "country": 'vn' },
  { "name": "ザライ省", "tw_name": "嘉萊府", "roman": "gia_lai", "country": 'vn' },
  { "name": "ダクラク省", "tw_name": "多樂省", "roman": "dac_lac", "country": 'vn' },
  { "name": "ダクノン省", "tw_name": "多農省", "roman": "dak_nong", "country": 'vn' },
  { "name": "ラムドン省", "tw_name": "林同省", "roman": "lam_dong", "country": 'vn' },
  { "name": "タイニン省", "tw_name": "西寧省", "roman": "tay_ninh", "country": 'vn' },
  { "name": "ドンナイ省", "tw_name": "同奈省", "roman": "dong_nai", "country": 'vn' },
  { "name": "バリア＝ブンタウ省", "tw_name": "巴地頭頓省", "roman": "ba_ria-vung_tau", "country": 'vn' },
  { "name": "ビンズオン省", "tw_name": "平陽省", "roman": "binh_duong", "country": 'vn' },
  { "name": "ビンフオック省", "tw_name": "永福省", "roman": "binh_phuoc", "country": 'vn' },
  { "name": "アンザン省", "tw_name": "安江省", "roman": "an_giang", "country": 'vn' },
  { "name": "ヴィンロン省", "tw_name": "永隆省", "roman": "vinh_long", "country": 'vn' },
  { "name": "カマウ省", "tw_name": "金甌省", "roman": "ca_mau", "country": 'vn' },
  { "name": "キエンザン省", "tw_name": "堅江省", "roman": "kien_giang", "country": 'vn' },
  { "name": "ソクチャン省", "tw_name": "朔莊省", "roman": "soc_trang", "country": 'vn' },
  { "name": "チャーヴィン省", "tw_name": "茶榮省", "roman": "tra_vinh", "country": 'vn' },
  { "name": "ティエンザン省", "tw_name": "前江省", "roman": "tien_giang", "country": 'vn' },
  { "name": "ハウザン省", "tw_name": "後江省", "roman": "hau_giang", "country": 'vn' },
  { "name": "バクリエウ省", "tw_name": "薄遼省", "roman": "bac_lieu", "country": 'vn' },
  { "name": "ベンチェ省", "tw_name": "檳椥省", "roman": "ben_tre", "country": 'vn' },
  { "name": "ドンタップ省", "tw_name": "同塔省", "roman": "dong_thap", "country": 'vn' },
  { "name": "ロンアン省", "tw_name": "隆安省", "roman": "long_an", "country": 'vn' }
]

const countryPrefectureNamesObject = {}
for(const prefecture of prefectures) {
  if(countryPrefectureNamesObject[prefecture.country] == undefined){
    countryPrefectureNamesObject[prefecture.country] = {}
  }

  let pref_name = prefecture.name
  if(languageHelper.pageLocale == 'zh-TW') {
    pref_name = prefecture.tw_name
  } else if (languageHelper.pageLocale == 'en') {
    pref_name = ucfirst(prefecture.roman)
  }

  countryPrefectureNamesObject[prefecture.country][prefecture.roman] = pref_name
}

export function countryPrefectureNames(country){
  // 最初だけ
  if (country === null || country === undefined || country === 'ja') {
    country = 'jp'
  }
  return countryPrefectureNamesObject[country]
}

export default prefectures
